import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqUGrUTqmeJvGgBQT3kEIUaDEY3ASVksM",
  authDomain: "commsk.firebaseapp.com",
  projectId: "commsk",
  storageBucket: "commsk.firebasestorage.app",
  messagingSenderId: "364182608637",
  appId: "1:364182608637:web:55279190b03c92ed7dbc94",
  measurementId: "G-D6P1JKY8PX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Initialize Analytics (optional)
let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.log('Analytics not available:', error);
}

export { db, analytics };
